import { IconName } from '@optimus-web/core';
import { LocalizedText, useFeatureFlag } from '@mews/framework';
import { TextKey, FeatureFlag } from '@mews-commander/enums';
import { isCurrentProfilePlatformAdmin } from '@mews-commander/legacy-entities/src/selectors/session/scope';
import { useCommanderSelector } from '@mews-commander/utils';
import { createListItemWithLink } from '../helpers';
import { SidebarExpandableListItem, SidebarFontIcon } from '../style';

interface Props {
    value: string;
}

export const QueueMenu = (props: Props) => {
    const isPlatformAdmin = useCommanderSelector(isCurrentProfilePlatformAdmin);
    const exportViewsV2Enabled = useFeatureFlag(FeatureFlag.exportViewsV2Enabled);
    const productProvisioningQueueItemViewEnabled = useFeatureFlag(FeatureFlag.productProvisioningQueueItemViewEnabled);

    if (!isPlatformAdmin) {
        return null;
    }

    return (
        <SidebarExpandableListItem
            leftIcon={<SidebarFontIcon value={IconName.Queues} />}
            primaryText={<LocalizedText textKey={TextKey.QueuePlural} />}
            {...props}
        >
            {createListItemWithLink({
                textKey: TextKey.JobPlural,
                iconName: IconName.Jobs,
                path: 'JobExecution/Index',
            })}
            {createListItemWithLink({
                textKey: TextKey.MailPlural,
                iconName: IconName.Mails,
                path: 'MailQueueItem/Index',
            })}
            {createListItemWithLink({
                textKey: TextKey.TextMessagePlural,
                iconName: IconName.MessagesPlural,
                path: 'TextMessageQueueItem/Index',
            })}
            {createListItemWithLink({
                textKey: TextKey.Ftp,
                iconName: IconName.Ftp,
                path: 'FtpQueueItem/Index',
            })}
            {createListItemWithLink({
                textKey: TextKey.Webhook,
                iconName: IconName.CustomLink,
                path: 'WebhookQueueItem/Index',
            })}
            {createListItemWithLink({
                textKey: TextKey.DeviceCommandPlural,
                iconName: IconName.DeviceCommand,
                path: 'DeviceCommand/Index',
            })}
            {createListItemWithLink({
                textKey: TextKey.ChannelManager,
                iconName: IconName.Languages,
                path: 'ChannelManagerQueueItem/Index',
            })}
            {createListItemWithLink({
                textKey: TextKey.ChannelManagerInventoryQueue,
                iconName: IconName.Refresh,
                path: 'ChannelManagerInventoryQueueItem/Index',
            })}
            {createListItemWithLink({
                textKey: TextKey.ChannelManagerStructureQueue,
                iconName: IconName.Refresh,
                path: 'ChannelManagerStructureQueueItem/Index',
            })}
            {createListItemWithLink({
                textKey: TextKey.ChannelManagerReservationSynchronizationQueueItemTitle,
                iconName: IconName.Refresh,
                path: 'ChannelManagerReservationSynchronizationQueueItem/Index',
            })}
            {createListItemWithLink({
                textKey: TextKey.PaymentGateway,
                iconName: IconName.PaymentReport,
                path: 'PaymentGatewayQueueItem/Index',
            })}
            {createListItemWithLink({
                textKey: TextKey.InstallationPlural,
                iconName: IconName.Installations,
                path: 'InstallationQueueItem/Index',
            })}
            {createListItemWithLink({
                textKey: TextKey.ImportPlural,
                iconName: IconName.Installations,
                path: 'ImportQueueItem/Index',
            })}
            {!exportViewsV2Enabled &&
                createListItemWithLink({
                    textKey: TextKey.ExportPlural,
                    iconName: IconName.Exports,
                    path: 'Export/Queue',
                })}
            {!exportViewsV2Enabled &&
                createListItemWithLink({
                    textKey: TextKey.ExportSchedulePlural,
                    iconName: IconName.Schedules,
                    path: 'ExportSchedule/Queue',
                })}
            {createListItemWithLink({
                textKey: TextKey.NotificationPlural,
                iconName: IconName.Notifications,
                path: 'Notification/Index',
            })}
            {createListItemWithLink({
                textKey: TextKey.PlatformMigrationPlural,
                iconName: IconName.PlatformMigrations,
                path: 'PlatformMigration/Index',
            })}
            {createListItemWithLink({
                textKey: TextKey.EnterpriseBuilderPro,
                iconName: IconName.Installations,
                path: 'EnterpriseBuilderProQueueItems/Index',
            })}
            {createListItemWithLink({
                textKey: TextKey.ConsumptionData,
                iconName: IconName.SharedData,
                path: 'ConsumptionDataQueueItem/Index',
            })}
            {productProvisioningQueueItemViewEnabled &&
                createListItemWithLink({
                    textKey: TextKey.ProductProvisioning,
                    iconName: IconName.SharedData,
                    path: 'ProductProvisioningQueueItem/Index',
                })}
        </SidebarExpandableListItem>
    );
};
